<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-6 w-full min-w-0">

    <div class="grid grid-cols-1 md:grid-cols-3 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">
        <!-- New vs. Returning -->

        <app-app-formed-company-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [formedCompanyData]="formedCompanyData"
        ></app-app-formed-company-pie-chart>

        <!-- Gender -->


        <app-app-patents-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [patentsData]="patentsData"
        ></app-app-patents-pie-chart>


        <app-app-lab-needed-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [labNeededData]="labNeededData"
        ></app-app-lab-needed-pie-chart>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">


        <app-app-funding-need-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [fundingNeedPieData]="fundingNeedPieData"
        ></app-app-funding-need-pie-chart>


        <app-app-origination-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [originationData]="originationData"
                [applicationList]="applicationList"
        ></app-app-origination-pie-chart>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8">


        <app-app-country-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [countryData]="countryData"
        ></app-app-country-pie-chart>

        <app-app-area-pie-chart
                class="flex flex-col flex-auto bg-card shadow rounded-2xl overflow-hidden p-4"
                [zoneData]="zoneData"
        ></app-app-area-pie-chart>

    </div>

    <app-app-trl-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForTrl]="appForTrl"
    >
    </app-app-trl-bar-chart>


    <app-app-for-region-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForRegion]="appForRegion"
    ></app-app-for-region-bar-chart>


    <app-app-region-batch-bar-chart
            class="col-span-2 md:col-span-6 flex gap-8 w-full mt-6 md:mt-8"
            [appForRegion]="appForRegion"
    ></app-app-region-batch-bar-chart>


</div>
